import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { Button } from "../../../components/Button";

interface IntroSheetProps {
  onContinue: () => void;
}

export function IntroSheet({ onContinue }: IntroSheetProps) {
  return (
    <Stack spacing={10} sx={{ px: 7, py: 8 }}>
      <Stack spacing={6}>
        <Text semibold variant="h3">
          Mark Interest for Future Facilities
        </Text>
        <Stack spacing={4}>
          <Text variant="h6">
            Discover facilities in your area that aren&apos;t on Clipboard Health yet. Tell us about
            which facilities you want to work at.
          </Text>
          <Text variant="h6">
            Express your interest and you&apos;ll be first in line when they join our platform.
          </Text>
        </Stack>
      </Stack>

      <Button fullWidth variant="contained" size="large" onClick={onContinue}>
        I Understand
      </Button>
    </Stack>
  );
}
